import React, { useEffect } from 'react';
import { ProgressStepper, Step, Button, Link } from '@paypalcorp/pp-react';
import PropTypes from 'prop-types';
import styles from './stepperStyles.less';
import * as analytics from '../../lib/analytics';

const StepperComponent = (props) => {
  const {
    stepsContent,
    isPrimaryModule,
    linkUrl,
    buttonText,
    instrumentation,
    authState,
    contentCountry,
    elmo,
  } = props;

  const commonAnalyticsTags = {
    account_type: authState === 'ANONYMOUS' ? 'guest' : 'member',
    acct_cntry: contentCountry,
    xe: elmo.idExperiments,
    xt: elmo.idTreatments,
    tile_id_type: 'steps_module',
  };

  useEffect(() => {
    if (instrumentation) {
      const {
        card_type,
        domain,
        item_name,
        module,
        scope,
        tile_id,
      } = instrumentation;

      analytics.instance.recordEvent(analytics.events.DW_GIVING_TILE_LOADED, {
        e: 'av',
        item_name,
        scope,
        state: 'loaded',
        card_type,
        tile_id,
        module,
        domain,
        ...commonAnalyticsTags,
      });

      analytics.instance.recordEvent(analytics.events.DW_GIVING_TILE_SHOWN, {
        e: 'im',
        item_name,
        scope,
        module,
        state: 'populated',
        card_type,
        tile_id,
        domain,
        ...commonAnalyticsTags,
      });
    }
  }, []);

  const recordEventOnClick = () => {
    const { card_type, item_name, module, scope, tile_id } = instrumentation;
    analytics.instance.recordEvent(analytics.events.DW_GIVING_TILE_PRESSED, {
      e: 'cl',
      item_name,
      state: 'populated',
      link_name: 'card',
      scope,
      module,
      tile_id,
      card_type,
      ...commonAnalyticsTags,
    });
  };

  return (
    <div>
      <ProgressStepper
        data-testid='progressStepper_stepperComponent'
        desktopVariant='vertical'
        className={`${!isPrimaryModule ? styles.progressStepperContrast : ''}`}
      >
        {stepsContent.map((step, index) => (
          <Step key={`index-${index}`} title={step.title} isNumeric>
            {step.description}
          </Step>
        ))}
      </ProgressStepper>
      <Link tabIndex={-1} href={linkUrl} className={styles.stepperButton}>
        <Button onClick={recordEventOnClick} inverse={!isPrimaryModule}>
          {buttonText}
        </Button>
      </Link>
    </div>
  );
};

StepperComponent.propTypes = {
  stepsContent: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      description: PropTypes.string,
    })
  ).isRequired,
  buttonText: PropTypes.string.isRequired,
  linkUrl: PropTypes.string.isRequired,
  isPrimaryModule: PropTypes.bool.isRequired,
  instrumentation: PropTypes.shape({
    card_type: PropTypes.string,
    domain: PropTypes.string,
    item_name: PropTypes.string,
    module: PropTypes.string,
    scope: PropTypes.string,
    tile_id: PropTypes.string,
  }),
  authState: PropTypes.string,
  contentCountry: PropTypes.string,
  elmo: PropTypes.object,
};

export { StepperComponent };
